import { alert } from '@pnotify/core';

import { translate } from './localize';

import '@pnotify/core/dist/PNotify.css';
import '@pnotify/core/dist/BrightTheme.css';

const REPORT_GROUP_RESERVATION_LIST = 'RES_BLOCK_LIST';
const REPORT_ROOMING_LIST = 'RES_BLOCK_ROOMING';
const REPORT_RESERVATION_SUMMARY = 'RES_BLOCK_SUMMARY';

const MAX_NUMBER_OF_NIGHTS = 62;

const PAX_FORM_PLACEHOLDER = 'GUEST';

const AVAILABILITY_INCREMENT = 1;
const AVAILABILITY_DECREMENT = -1;

const PROCESSES_NUMBER_TO_REFRESH = 10;

const REPORT_TYPE_DESC = [];
REPORT_TYPE_DESC[REPORT_GROUP_RESERVATION_LIST] = 'BLOCK_RES_';
REPORT_TYPE_DESC[REPORT_ROOMING_LIST] = 'ROOMING_';
REPORT_TYPE_DESC[REPORT_RESERVATION_SUMMARY] = 'RESERVATIONS_';

const FREE_RESERVATION_MIN_PERCENTAGE = 99.99;

const STATUS_CONFIRMED = 'CONF';
const STATUS_CANCELED = 'CAN';
const STATUS_ALL = 'ALL';

const PAXES_ADULT_TYPE = 'ADULT';
const PAXES_CHILDREN_TYPE = 'CHILD';

const REPORT_FILE_TYPE = {
  xls: 'XLS',
  xlsx: 'XLSX',
  csv: 'CSV'
};

const MAP_NUMBER_STRING = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

const PMS_RESERV_TYPE = 'P';

const scrollIntoView = (elemId) => {
  const elem = document.getElementById(elemId);
  if (elem) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }
};

const numberToString = number => ((number < 10) ? `0${number}` : number.toString());

const getHotelNameByCode = (hotelCode, hotelsList) => {
  const filteredHotel = hotelsList.filter(hotel => hotel.value.toString() === hotelCode.toString());

  if (filteredHotel && typeof filteredHotel[0] !== 'undefined') {
    return filteredHotel[0].label;
  }

  return '';
};

const getLabelValueOptionsList = (numberOf, addZeroOption) => {
  if (numberOf) {
    const finalList = Array.from(new Array(numberOf).keys()).map(
      index => ({ value: index + 1, label: (index + 1).toString() })
    );

    if (addZeroOption) {
      finalList.unshift({ value: 0, label: '0' });
    }

    return finalList;
  }

  return [];
};

const orderObjectsListAlphabetically = (objectList, objectValue) => {
  return objectList.sort((a, b) => {
    if (a && a[objectValue] && b && b[objectValue]) {
      const textA = a[objectValue].toString().toUpperCase();
      const textB = b[objectValue].toString().toUpperCase();
      const checkBigger = (textA > textB) ? 1 : 0;

      return (textA < textB) ? -1 : checkBigger;
    }

    return 0;
  });
};

const showNotification = (title, text, replacers) => {
  alert({
    title: translate(title),
    text: translate(text, replacers),
    textTrusted: true,
    addClass: 'custom-pntofy',
    icon: 'fas fa-bell',
    hide: true,
    remove: true,
    destroy: true,
    delay: 3500,
    mouseReset: false,
    modules: {
      Buttons: {
        closer: true,
        sticker: false,
        labels: {
          close: translate('cerrar')
        }
      }
    }
  });
};

const localizeAmount = (amount, currencyCode) => {
  const locale = currencyCode === 'USD' ? 'en-US' : 'es-ES';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true
  }).format(amount);
};

const getLiteralCurrency = (currencyCode) => {
  switch (currencyCode) {
    case 'EUR': {
      return '€';
    }
    case 'GBP': {
      return '£';
    }
    case 'USD': {
      return '$';
    }
    default: {
      return currencyCode || '';
    }
  }
};

const getLetterFromIndex = (value) => {
  let response = String(value);
  MAP_NUMBER_STRING.forEach((e, index) => { response = response.replace(String(index), e, 'g'); });

  return response;
};

// Reservation Notifications
const createdNotification = () => {
  showNotification('seHaCreadoReserva', 'createReservationSuccess');
};
const updatedNotification = (locator) => {
  showNotification('seHaModificadoReserva', 'updateReservationSuccess', [locator]);
};
const canceledNotification = (locator) => {
  showNotification('seHaCanceladoReserva', 'exitoCancelacionReserva', [locator]);
};

const mapToOptionsList = (oldList, labelKey, valueKey) => {
  if (!oldList) return [];

  if (!labelKey || !valueKey) return oldList;

  return oldList.map(listItem => ({
    label: listItem[labelKey],
    value: listItem[valueKey]
  }));
};

export {
  REPORT_GROUP_RESERVATION_LIST,
  REPORT_ROOMING_LIST,
  REPORT_RESERVATION_SUMMARY,
  MAX_NUMBER_OF_NIGHTS,
  PAX_FORM_PLACEHOLDER,
  AVAILABILITY_INCREMENT,
  AVAILABILITY_DECREMENT,
  REPORT_FILE_TYPE,
  REPORT_TYPE_DESC,
  PROCESSES_NUMBER_TO_REFRESH,
  STATUS_CONFIRMED,
  STATUS_CANCELED,
  STATUS_ALL,
  PAXES_ADULT_TYPE,
  PAXES_CHILDREN_TYPE,
  FREE_RESERVATION_MIN_PERCENTAGE,
  PMS_RESERV_TYPE,
  getHotelNameByCode,
  getLabelValueOptionsList,
  scrollIntoView,
  numberToString,
  orderObjectsListAlphabetically,
  showNotification,
  localizeAmount,
  getLiteralCurrency,
  getLetterFromIndex,
  createdNotification,
  updatedNotification,
  canceledNotification,
  mapToOptionsList
};
